import { Firm, Person } from "../backend-definitions.module";
import { Order } from "./order";

export class OrderPayer {
    id: number;
    order: Order;
    firm: Firm;
    person: Person;
    dated: string;
    invoice: string;
}
